export default __webpack_public_path__ + "static/media/linkedinw.34c64d9e.svg";